import React, { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import {
  IonContent,
  IonPage,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
} from "@ionic/react";
import { ChallengeCard } from "../components/challenges/ChallengeCard";
import { HelpoHeader } from "../components/shared/HelpoHeader";
import { IChallenge } from "../models/IChallenge";
import { EmptyChallenge } from "../models/EmptyChallenge";
import { ApiService } from "../services/ApiService";
import { HelpoDivider } from "../components/shared/HelpoDivider";
import { SocialSharingButtons } from "../components/shared/SocialSharingButtons";
import { CallToAction } from "../components/callToActions/CallToAction";
import styles from "./ChallengeDetail.module.css";
import {
  usePersistedState,
  States,
} from "../components/challenges/usePersistedState";

interface ChallengeDetailProps extends RouteComponentProps<{ id: string }> {
  challenge?: IChallenge;
}

export const ChallengeDetail: React.FC<ChallengeDetailProps> = ({
  match,
  challenge = new EmptyChallenge(),
}) => {
  const [currentChallenge, setCurrentChallenge] = useState<IChallenge>(
    challenge
  );
  const [storedValue] = usePersistedState(
    currentChallenge.Guid,
    States.Incomplete
  );

  console.log("detail", storedValue);
  useEffect(() => {
    let api = new ApiService();
    api.GetSingleChallenge(match.params.id).then((c) => {
      setCurrentChallenge(c ? c : new EmptyChallenge());
    });
  }, [match.params.id]);

  return (
    <IonPage>
      <HelpoHeader title={currentChallenge.Title} />
      <IonContent>
        <IonGrid className="ion-no-padding">
          <IonRow className="ion-justify-content-center">
            <IonCol size="12" sizeMd="8">
              <ChallengeCard
                guid={currentChallenge.Guid}
                subtitle={currentChallenge.Subtitle}
                imageSrc={currentChallenge.ImageSrc}
              />
            </IonCol>
          </IonRow>
          {currentChallenge.CallToActions.length > 0 && (
            <IonRow
              className={`ion-justify-content-center ${styles.callToActionContainer}`}
            >
              <IonCol size="12">
                <IonText className="ion-text-center" color="primary">
                  <p>DO</p>
                  <HelpoDivider />
                </IonText>
              </IonCol>
              {currentChallenge.CallToActions.map((cta, index) => (
                <CallToAction cta={cta} key={index} />
              ))}
            </IonRow>
          )}
          <SocialSharingButtons Guid={currentChallenge.Guid} />
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
